<div class="title-container">
  <div class="title">{{ getTitle() | translate }}</div>
</div>
<div [hidden]="isLoading()">
  <mat-dialog-content>
    <div class="description">
      {{ 'BUSINESS_PROFILE.SHARE_FIELDS' | translate }}
      <mat-icon [glxyTooltip]="'BUSINESS_PROFILE.SHARE_FIELDS_TOOLTIP' | translate" class="info-icon">
        info_outline
      </mat-icon>
    </div>

    @if (!data.excludeAddToAIStep) {
      <ai-knowledge-application-selector
        #applicationSelector
        [knowledgeSourceId]="knowledgeSource?.id"
        (createWidgetClicked)="createWebChatWidget()"
      ></ai-knowledge-application-selector>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div class="actions">
      @if (customButton?.link && otherAIDisclaimer()) {
        <div class="used-with-other-ai">{{ otherAIDisclaimer() }}</div>
      }
      <div class="buttons">
        @if (customButton?.link) {
          <div class="card-actions__secondary">
            <a mat-stroked-button color="secondary" [href]="customButton?.link" target="_blank">
              {{ customButton?.text | translate }}
              <mat-icon iconPositionEnd>open_in_new</mat-icon>
            </a>
          </div>
        }

        <div class="card-actions__primary">
          @if (data?.excludeAddToAIStep) {
            <button mat-flat-button color="primary" (click)="close()">{{ 'COMMON.CLOSE' | translate }}</button>
          } @else {
            <button mat-stroked-button (click)="close()">{{ 'COMMON.CLOSE' | translate }}</button>
            <button mat-flat-button color="primary" (click)="submit()">
              {{ 'COMMON.SAVE' | translate }}
            </button>
          }
        </div>
      </div>
    </div>
  </mat-dialog-actions>
</div>

<glxy-loading-spinner *ngIf="isLoading()"></glxy-loading-spinner>
